import { createContext, useContext, useEffect, useState } from "react";
import { getMe, setToken, clearToken, getToken } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = checking, false = signed out, object = signed in
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!getToken()) {
      setUser(false);
      return;
    }
    getMe()
      .then(setUser)
      .catch(() => {
        clearToken();
        setUser(false);
      });
  }, []);

  const signIn = (token, u) => {
    setToken(token);
    setUser(u);
  };
  const signOut = () => {
    clearToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, signIn, signOut }}>{children}</AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
